"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Input, } from '@angular/core';
import { UI_CONFIG } from '../ui.config';
var ImageThumbnailComponent = (function () {
    function ImageThumbnailComponent(changeDetectorRef, uiConfig) {
        this.changeDetectorRef = changeDetectorRef;
        this.uiConfig = uiConfig;
        this.forcePlaceholder = false;
        this.size = 'mid';
        this.clickable = true;
        this.placeholder = this.uiConfig
            .assetsBaseUrl + "/image-thumbnail-placeholder.svg";
    }
    ImageThumbnailComponent.prototype.getDisplayImage = function () {
        if (this.forcePlaceholder) {
            return this.placeholder;
        }
        return this.src || this.placeholder;
    };
    ImageThumbnailComponent.prototype.onImageFetchError = function () {
        if (!this.forcePlaceholder) {
            // Well this sucks. Show the placeholder for now.
            this.forcePlaceholder = true;
            this.changeDetectorRef.markForCheck();
        }
    };
    ImageThumbnailComponent.prototype.ngOnChanges = function (changes) {
        var changedInputs = Object.keys(changes);
        if (changedInputs.includes('src')) {
            // There's a possibility that the new `src` can be a working image. Flip
            // forcePlaceholder to false to check.
            this.forcePlaceholder = false;
        }
    };
    __decorate([
        HostBinding('attr.size'),
        Input(),
        __metadata("design:type", String)
    ], ImageThumbnailComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ImageThumbnailComponent.prototype, "alt", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ImageThumbnailComponent.prototype, "src", void 0);
    __decorate([
        HostBinding('attr.clickable'),
        Input(),
        __metadata("design:type", Object)
    ], ImageThumbnailComponent.prototype, "clickable", void 0);
    __decorate([
        HostBinding('attr.circular'),
        Input(),
        __metadata("design:type", Boolean)
    ], ImageThumbnailComponent.prototype, "circular", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ImageThumbnailComponent.prototype, "placeholder", void 0);
    ImageThumbnailComponent = __decorate([
        Component({
            selector: 'fl-image-thumbnail',
            template: "\n    <figure class=\"ImageContainer\">\n      <img [src]=\"getDisplayImage()\" [alt]=\"alt\" class=\"Image\" (error)=\"onImageFetchError()\">\n    </figure>\n  ",
            changeDetection: ChangeDetectionStrategy.OnPush,
            styleUrls: ['./image-thumbnail.component.scss'],
        }),
        __param(1, Inject(UI_CONFIG)),
        __metadata("design:paramtypes", [ChangeDetectorRef, Object])
    ], ImageThumbnailComponent);
    return ImageThumbnailComponent;
}());
export { ImageThumbnailComponent };



// WEBPACK FOOTER //
// image-thumbnail.component.js